/* tslint:disable */
/* eslint-disable */
import { NgModule, ModuleWithProviders, SkipSelf, Optional } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ApiConfiguration, ApiConfigurationParams } from './api-configuration';

import { IdentityBackendService } from './services/identity-backend.service';
import { ProductDocumentBackendService } from './services/product-document-backend.service';
import { ProductBackendService } from './services/product-backend.service';
import { SubscriptionBackendService } from './services/subscription-backend.service';
import { SamplesBackendService } from './services/samples-backend.service';
import { TelemetryBackendService } from './services/telemetry-backend.service';
import { SubscriptionEmailBackendService } from './services/subscription-email-backend.service';

/**
 * Module that provides all services and configuration.
 */
@NgModule({
  imports: [],
  exports: [],
  declarations: [],
  providers: [
    IdentityBackendService,
    ProductDocumentBackendService,
    ProductBackendService,
    SubscriptionBackendService,
    SamplesBackendService,
    TelemetryBackendService,
    SubscriptionEmailBackendService,
    ApiConfiguration
  ],
})
export class ApiModule {
  static forRoot(params: ApiConfigurationParams): ModuleWithProviders<ApiModule> {
    return {
      ngModule: ApiModule,
      providers: [
        {
          provide: ApiConfiguration,
          useValue: params
        }
      ]
    }
  }

  constructor( 
    @Optional() @SkipSelf() parentModule: ApiModule,
    @Optional() http: HttpClient
  ) {
    if (parentModule) {
      throw new Error('ApiModule is already loaded. Import in your base AppModule only.');
    }
    if (!http) {
      throw new Error('You need to import the HttpClientModule in your AppModule! \n' +
      'See also https://github.com/angular/angular/issues/20575');
    }
  }
}
